/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();

// New agent and datasource information
const agent_name = 'AI Sales Agent';
const datasource1 = 'Sales Database';

export const activities = [
    {
        id: 'initialization-start',
        icon: 'heroicons_outline:play',
        description: `Initialized autonomous ${agent_name} operation for datasource: ${datasource1}`,
        date: now.toISO(),
        extraContent: 'Starting the data analysis operation.',
    },
    {
        id: 'data-analysis',
        icon: 'heroicons_outline:magnifying-glass',
        description: 'Analyzing datasource structure and understanding data points.',
        date: now.minus({ minutes: 5 }).toISO(),
    },
    {
        id: 'query-generation',
        icon: 'heroicons_outline:code-bracket-square',
        description: 'Generating list of queries based on retrieved data structure.',
        date: now.minus({ minutes: 10 }).toISO(),
    },
    {
        id: 'query-execution-start',
        icon: 'heroicons_outline:cube-transparent',
        description: 'Begin sequential query execution.',
        date: now.minus({ minutes: 15 }).toISO(),
    },
    {
        id: 'query-progress',
        icon: 'heroicons_outline:arrow-right-circle',
        description: 'Query execution in progress: 10/25.',
        date: now.minus({ minutes: 20 }).toISO(),
    },
    {
        id: 'query-completion',
        icon: 'heroicons_outline:check-circle',
        description: 'Query execution completed.',
        date: now.minus({ minutes: 25 }).toISO(),
    },
    {
        id: 'results-compilation',
        icon: 'heroicons_outline:bookmark-square',
        description: 'Compiling intermediate results.',
        date: now.minus({ minutes: 30 }).toISO(),
    },
    {
        id: 'data-interpretation',
        icon: 'heroicons_outline:chart-bar-square',
        description: 'Generating results interpretations and summarization.',
        date: now.minus({ minutes: 35 }).toISO(),
    },
    {
        id: 'report-generation',
        icon: 'heroicons_outline:bookmark',
        description: 'Generating comprehensive report.',
        date: now.minus({ minutes: 40 }).toISO(),
    },
    {
        id: 'chart-table-creation',
        icon: 'heroicons_outline:table-cells',
        description: 'Generating charts and data tables.',
        date: now.minus({ minutes: 45 }).toISO(),
    },
    {
        id: 'report-distribution',
        icon: 'heroicons_outline:chat-bubble-oval-left-ellipsis',
        description: 'Distributing Final Report.',
        date: now.minus({ minutes: 50 }).toISO(),
    },
    {
        id: 'operation-completion',
        icon: 'heroicons_outline:flag',
        description: `The autonomous ${agent_name} operation for datasource: ${datasource1} is completed successfully.`,
        date: now.minus({ minutes: 55 }).toISO(),
        extraContent: `Execution results = 25 generated queries, 23 successful execution, 2 failed execution. 15 data tables generated, 17 charts generated, 25436 data points analyzed.`,
    },
];

function updateActivities(activities, agentName, dataSource) {
    return activities.map(activity => {
        let updatedActivity = { ...activity };

        updatedActivity.description = updatedActivity.description.replace(/\${agent_name}/g, agentName).replace(/\${datasource1}/g, dataSource);
        if (updatedActivity.description.includes(agentName)) {
            updatedActivity = { ...updatedActivity, image: 'assets/images/agent1.jpg',name:agentName }
            
        }

        return updatedActivity;
    });
}

export const updatedActivities = updateActivities(activities, agent_name, datasource1);

